import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export const Main = (props)=>/*#__PURE__*/ _jsx("main", {
        className: "main",
        id: "a11y-main",
        children: props.children
    });
{}